
// region JS Imports

// region External Modules
import on_domready from "domready"
// endregion External Modules

// Private Modules
import DataRetriever from "app/data_retriever"
import ImageLazyLoading from "widgets/image_lazyloading"
// Private Modules

// region Public Components
import BS3_Dropdown from "components/bootstrap3-like-dropdown"

import {
  init as CountryFollowButton_init,
} from "apps/spacious_website/components/countries/follow_button"
import {
  Factory as CountryFollowPromptModal,
} from "apps/spacious_website/components/countries/follow_prompt_modal"
// endregion Public Components

// region Private Components
import {
  load_and_inject_content as load_and_inject_below_the_fold_section,
} from "./below_the_fold_section"

import {
  Factory as OverseasMarketingStickyBar,
} from "./components/sticky_bar/index"
import {
  Factory as OverseasMarketingFilter,
} from "./components/overseas_marketing_filter/index"
// endregion Private Components

// endregion JS Imports


const init = () => {
  BS3_Dropdown.init({
    scope:              ".main-content-container",
    dropdown_toggle:    ".dropdown-toggle",
    dropdown_container: ".dropdown",
  })

  CountryFollowPromptModal.create()
  CountryFollowButton_init().done()

  OverseasMarketingStickyBar.create()
  OverseasMarketingFilter.create()


  // Disabled to observe effect of conversion rate
  // ProjectDetailEnquiryFormModal.create()

  on_domready(() => {
    const country_id = DataRetriever.get("country-id")

    load_and_inject_below_the_fold_section(country_id)
    .then(() => {
      ImageLazyLoading.default_lazyload_instance().update()
    })
  })
}

export default {
  init: init,
}
